module.exports = __webpack_public_path__ + "img/41.097d5d34.jpg";